import React from 'react';
import SearchIcon from '../../svgIcons/SearchIcon';
import './SearchInput.css';

interface SearchInputProps {
    value: string;
    placeholder?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    searchContainerStyle?: string;
    style?: React.CSSProperties;
}

const SearchInput: React.FC<SearchInputProps> = ({
    value,
    placeholder = 'Search...',
    onChange,
    searchContainerStyle,
    style,
}) => {

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let trimmedValue = e.target.value
            .replace(/^\s+/, '')
        if (onChange) {
            onChange({
                ...e,
                target: {
                    ...e.target,
                    value: trimmedValue,
                },
            });
        }
    };

    return (
        <div className={`search-container ${searchContainerStyle || ''}`} style={style}>
            <input
                type="text"
                value={value}
                onChange={handleChange}
                placeholder={placeholder}
                className="search-input"
            />
            <div className="search-icon">
                <SearchIcon width={17} height={17} fill="#000000" />
            </div>
        </div>
    );
};

export default SearchInput;
